module.exports = __webpack_public_path__ + "img/Case_11.947146fd.jpg";